<template>
  <main-template>
    <v-row class="mb-1">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Minhas Faltas Justificadas
        </h1>
      </v-col>
    </v-row>

    <v-row class="mb-3">
      <v-col cols="auto">
        <v-btn color="primary" :to="{ name: 'colaboradores.faltasJustificadas.nova' }">
          <v-icon left>mdi-plus</v-icon>
          Nova Justificativa
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="faltas"
          :loading="carregando"
          no-data-text="Nenhuma justificativa enviada"
          loading-text="Carregando..."
        >
          <template #[`item.data_inicio`]="{ item }">
            {{ formatarData(item.data_inicio) }}
            <span v-if="item.data_fim"> até {{ formatarData(item.data_fim) }}</span>
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip small :color="corStatus(item.status)" dark>
              {{ item.status }}
            </v-chip>
          </template>
          <template #[`item.documento`]="{ item }">
            <v-tooltip v-if="item.documento" bottom>
              <template #activator="{ on }">
                <v-btn
                  icon
                  small
                  color="primary"
                  :loading="abrindoDocumento === item.id"
                  v-on="on"
                  @click="abrirDocumento(item)"
                >
                  <v-icon small>mdi-paperclip</v-icon>
                </v-btn>
              </template>
              <span>Documento</span>
            </v-tooltip>
            <span v-else class="grey--text text--lighten-1">—</span>
          </template>
          <template #[`item.acoes`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="primary" v-on="on" @click="visualizar(item)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  icon
                  small
                  color="warning"
                  :disabled="item.status !== 'pendente'"
                  v-on="on"
                  @click="editar(item)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn
                  icon
                  small
                  color="error"
                  :disabled="item.status !== 'pendente'"
                  v-on="on"
                  @click="confirmarDeletar(item)"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogVisualizar" max-width="600">
      <v-card v-if="itemVisualizado">
        <v-card-title class="d-flex align-center justify-space-between">
          <span>Detalhes da Justificativa</span>
          <v-chip small :color="corStatus(itemVisualizado.status)" dark>
            {{ itemVisualizado.status }}
          </v-chip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="6">
              <div class="caption grey--text text--darken-1">Data da Falta</div>
              <div class="body-2 font-weight-medium">
                {{ formatarData(itemVisualizado.data_inicio) }}
                <span v-if="itemVisualizado.data_fim">
                  até {{ formatarData(itemVisualizado.data_fim) }}
                </span>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="caption grey--text text--darken-1">Enviado em</div>
              <div class="body-2">{{ formatarDataHora(itemVisualizado.created_at) }}</div>
            </v-col>
            <v-col cols="12">
              <div class="caption grey--text text--darken-1 mt-2">Motivo</div>
              <div class="body-2">{{ itemVisualizado.motivo }}</div>
            </v-col>
            <v-col v-if="itemVisualizado.observacao" cols="12">
              <div class="caption grey--text text--darken-1 mt-2">Observação</div>
              <div class="body-2">{{ itemVisualizado.observacao }}</div>
            </v-col>
            <template v-if="itemVisualizado.status !== 'pendente'">
              <v-col cols="12"><v-divider class="my-2" /></v-col>
              <v-col cols="6">
                <div class="caption grey--text text--darken-1">Avaliado por</div>
                <div class="body-2">
                  {{
                    itemVisualizado.avaliador && itemVisualizado.avaliador.name
                      ? itemVisualizado.avaliador.name
                      : "—"
                  }}
                </div>
              </v-col>
              <v-col v-if="itemVisualizado.observacao_avaliador" cols="12">
                <div class="caption grey--text text--darken-1 mt-1">Resposta do avaliador</div>
                <div class="body-2">{{ itemVisualizado.observacao_avaliador }}</div>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogVisualizar = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeletar" max-width="420">
      <v-card>
        <v-card-title>Confirmar Exclusão</v-card-title>
        <v-card-text>
          Deseja excluir a justificativa de
          <strong>{{ formatarData(itemParaDeletar && itemParaDeletar.data_inicio) }}</strong
          >? Esta ação não pode ser desfeita.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="deletando" @click="dialogDeletar = false">Cancelar</v-btn>
          <v-btn color="error" :loading="deletando" @click="deletar">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "FaltaJustificadaPage",
  data() {
    return {
      faltas: [],
      carregando: false,
      abrindoDocumento: null,
      dialogVisualizar: false,
      itemVisualizado: null,
      dialogDeletar: false,
      deletando: false,
      itemParaDeletar: null,
      headers: [
        { text: "Data da Falta", value: "data_inicio" },
        { text: "Motivo", value: "motivo" },
        { text: "Status", value: "status" },
        { text: "Anexo", value: "documento", align: "center", sortable: false, width: "60" },
        { text: "Observação do Avaliador", value: "observacao_avaliador" },
        { text: "", value: "acoes", sortable: false, align: "center", width: "120" },
      ],
    };
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        this.faltas =
          await this.$services.colaboradorPontosService.listarMinhasFaltasJustificadas();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    visualizar(item) {
      this.itemVisualizado = item;
      this.dialogVisualizar = true;
    },
    editar(item) {
      this.$router.push({
        name: "colaboradores.faltasJustificadas.nova",
        query: { editarId: item.id },
      });
    },
    confirmarDeletar(item) {
      this.itemParaDeletar = item;
      this.dialogDeletar = true;
    },
    async deletar() {
      try {
        this.deletando = true;
        await this.$services.colaboradorPontosService.excluirMinhaFaltaJustificada(
          this.itemParaDeletar.id
        );
        this.$toast.success("Justificativa excluída com sucesso!");
        this.dialogDeletar = false;
        await this.carregar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.deletando = false;
      }
    },
    async abrirDocumento(item) {
      try {
        this.abrindoDocumento = item.id;
        await this.$services.colaboradorPontosService.meuDocumentoFalta(item.id);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.abrindoDocumento = null;
      }
    },
    corStatus(status) {
      return { pendente: "orange", aprovado: "green", reprovado: "red" }[status] || "grey";
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarDataHora(data) {
      if (!data) return "—";
      return new Date(data).toLocaleString("pt-BR");
    },
  },
};
</script>
